import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=821b38ba&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=821b38ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821b38ba",
  null
  
)

export default component.exports